/*!
 *  (c)(r) 2008-2025 IT-Service Robert Frunzke
 */

// import { xxx } from './fetch-util.js';



/**
	let cnrReqsUtil = new ConcurrentRequestsUtil(deferablesList,promisesList);

	cnrReqsUtil.addRequest( function( success_cb, error_cb ) {
		return postToBackend2(
			url,
			data,
			success_cb,
			() => error_cb('timeout'),
			(jqXHR,textStatus,message) => error_cb( [textStatus,message].join("\n").trim() ),
			true
		);
	} );


	// either
		cnrReqsUtil.runAllWithCallbacks(
			(dataArr) => console.log(dataArr),
			(reason) => console.log('error: '+reason)
		);

	// or
		cnrReqsUtil.runAllWithPromise()
			.then( (dataArr) => console.log(dataArr) )
			.catch( (reason) => console.log('error: '+reason) )

	// or
		try {
			const dataArr = await cnrReqsUtil.runAllWithPromise();
			console.log(dataArr);
		} catch( error ) {
			console.log('error: '+error);
		}


	// abort() pending requests
	cnrReqsUtil.abort();

	// or
	cnrReqsUtil = cancelBackendRequest(cnrReqsUtil);

 */

class ConcurrentRequestsUtil {

	constructor( ) {
		this.deferablesList = [];
		this.promisesList = [];
		this.combinedPromise = null;
	}

	addRequest( sendRequest ) {
		if( this.combinedPromise != null ) throw new Error('can not add requests after run*()');
		// const args = Array.prototype.slice.call(arguments,1);
		const promise = new Promise( (resolve,reject) => {
			const deferable = sendRequest(
				(...data) => {
					return resolve(...data);
				},
				(error) => {
					return reject(error);
				}
			);
			this.deferablesList.push(deferable);
		} );
		this.promisesList.push(promise);
	}

	runAllWithPromise() {
		return this.combinedPromise = Promise.all( this.promisesList )
			.catch( (error) => {
				// console.dir( {w:'runAllWithPromise catch..',error,dfrblsList:this.deferablesList,prmssList:this.promisesList} );
				// // console.log( JSON.stringify( {w:'runAllWithPromise catch..',error,dfrblsList:this.deferablesList,prmssList:this.promisesList} ) );
				// debugger;
				this.abort();
				return error;
			} );
	}

	async runAllWithCallbacks( success_cb, error_cb ) {
		try {
			const dataArr = await this.runAllWithPromise();
			return success_cb.apply(null,dataArr );
		} catch( error ) {
			return error_cb.call(null,error);
		}
	}

	state() {
		for( const [,deferable] of this.deferablesList.entries() ) {
			if( deferable===undefined || deferable===null ) continue;
			const stateStr = deferable.state();
			if( stateStr==='pending' ) return stateStr;
			if( stateStr!=='resolved' ) return stateStr;
		}
		return 'resolved';
	}

	abort() {
		for( const [,deferable] of this.deferablesList.entries() ) {
			if( deferable===undefined || deferable===null ) continue;

			// console.trace( {w:'ablrt....',deferable,xx:JSON.stringify(deferable)} );

			if( deferable.state ) {
				const stateStr = deferable.state();
				if( stateStr==='pending' ) {
					deferable.abort();
				}
			} else {
				// actually not a deferable, probably a promise
				// -> can not abort (yet)
				// -> silently ignore
			}
		}
	}
}





export {
	// eslint-disable-next-line import/no-unused-modules
	ConcurrentRequestsUtil
};

